import React from 'react';

import { Box, Flex } from '@rover/kibble/core';
import LoadingShimmer from '@rover/kibble/patterns/LoadingShimmer';

const ServiceHeaderLoadingShimmer = (): JSX.Element => (
  <Flex
    width="100%"
    flexDirection="row"
    justifyContent="space-between"
    data-testid="service-header-loading-shimmer"
  >
    <Box>
      <Flex flexDirection="row">
        <LoadingShimmer width={38} height={38} margin="0x" />
        <Flex flexDirection="column" justifyContent="space-between" marginLeft="1x" gap="1x">
          <LoadingShimmer width={134} height={24} margin="0x" />
          <LoadingShimmer width={128} height={18} margin="0x" />
        </Flex>
      </Flex>
    </Box>
    <Flex flexDirection="column" gap="1x">
      <LoadingShimmer width={36} height={24} margin="0x" alignSelf="flex-end" />
      <LoadingShimmer width={58} height={18} margin="0x" />
    </Flex>
  </Flex>
);

export default ServiceHeaderLoadingShimmer;
